export default __webpack_public_path__ + "static/connor-group-central-support-office-7c081d1e149e49aa6f6526c19d37500b.jpg";